import { action } from "../utils/requests";

export const create = (bg, txt) => {
	return action("create_captcha", { bg: bg, txt: txt }).then((res) => {
		setTimeout(() => {
			sessionStorage.removeItem("captcha");
		}, 300000);

		sessionStorage.setItem("captcha", JSON.stringify(res));
		return res;
	});
};

export const validate = (prefix, answer) => {
	return action("validate_captcha", { prefix, answer }).then((res) => {
		return res;
	});
};

export const remove = (prefix) => {
	return action("remove_captcha", { prefix }).then((res) => {
		return res;
	});
};

export const prefix = () => {
	return JSON.parse(sessionStorage.getItem("captcha")).prefix;
};

export default {
	create,
	validate,
	remove,
	prefix,
};
